import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-wrap align-items-center justify-content-center w-screen h-screen" }
const _hoisted_2 = { class: "w-auto m-3 flex align-items-center justify-content-center" }
const _hoisted_3 = { class: "form-icon" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "p-2" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Login", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "input-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-at" })
], -1)
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "input-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" })
], -1)
const _hoisted_17 = {
  key: 2,
  class: "forgot-pass"
}

export function render(_ctx, _cache) {
  const _component_loading = _resolveComponent("loading")
  const _component_p_inline_message = _resolveComponent("p-inline-message")
  const _component_p_inputtext = _resolveComponent("p-inputtext")
  const _component_p_button = _resolveComponent("p-button")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = $event => ((_ctx.isLoading) = $event)),
      "can-cancel": false,
      "is-full-page": true,
      color: _ctx.app_base_data.main_theme_color,
      loader: "bars",
      "background-color": "app_base_data.second_theme_color"
    }, null, 8, ["active", "color"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "form-container",
          style: _normalizeStyle({background:_ctx.gradientStyle})
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.app_base_data.main_icon !== '')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "rounded-circle shadow-4-strong",
                    alt: "avatar2",
                    width: "90",
                    height: "90",
                    src: _ctx.app_base_data.main_icon
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("h1", _hoisted_6, _hoisted_8))
            ]),
            _hoisted_9,
            _createElementVNode("h5", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.app_base_data.company_name), 1)
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.app_base_data.tag_line_one) + ". " + _toDisplayString(_ctx.app_base_data.tag_line_two), 1)
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
            class: "form-horizontal"
          }, [
            _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.app_base_data.app_name), 1),
            _hoisted_12,
            (_ctx.isInvalid.username.status)
              ? (_openBlock(), _createBlock(_component_p_inline_message, {
                  key: 0,
                  severity: "error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Username / Email Wajib Diisi")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_p_inputtext, {
                class: _normalizeClass(["form-control", {'is-invalid' : _ctx.isInvalid.username.status}]),
                type: "text",
                modelValue: _ctx.user.username,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.user.username) = $event)),
                placeholder: "Email / Username"
              }, null, 8, ["modelValue", "class"])
            ]),
            (_ctx.isInvalid.password.status)
              ? (_openBlock(), _createBlock(_component_p_inline_message, {
                  key: 1,
                  severity: "error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Password Wajib Diisi")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_p_inputtext, {
                class: _normalizeClass(["form-control", {'is-invalid' : _ctx.isInvalid.password.status}]),
                type: "password",
                modelValue: _ctx.user.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.user.password) = $event)),
                placeholder: "Password"
              }, null, 8, ["modelValue", "class"])
            ]),
            _createVNode(_component_p_button, {
              type: "submit",
              class: "w-full mb-5 btn signin",
              label: "LOGIN",
              severity: "danger",
              rounded: ""
            }),
            (_ctx.app_base_config.register.allow_register)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  _createVNode(_component_router_link, { to: "/register" }, {
                    default: _withCtx(() => [
                      _createTextVNode("REGISTER NEW USER")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ], 4)
      ])
    ])
  ], 64))
}